import React, { ReactNode } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

interface ConditionalTooltipProps {
  children: ReactNode;
  tooltip?: string;
  placement?: TooltipProps['placement'];
}

const ConditionalTooltip: React.FC<ConditionalTooltipProps> = ({
  children,
  tooltip,
  placement,
}) => {
  if (!tooltip) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={tooltip} placement={placement}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default ConditionalTooltip;
